import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
// import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
// import {renderCheckbox} from '../../../../atoms/CustomPart.js';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
  // createTyohyoPdf,
  getCodeFromGeneralPurposeMap,
  // changeDateFormat,
  // getErrorCode,
  // API_CODE,
  // getErrorMessages,
  // getResponseResult,
  // getDataFromGeneralPurposeMap,
  // getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
// import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import {renderSelect, renderCheckbox} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
// import CustomBreadcrumbs from '../../../../molecules/Breadcrumbs.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import {
  Link,
  Breadcrumbs,
  FormControl,
  FormGroup,
  FormLabel,
} from '@mui/material';

const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    // fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: 0,
  },
});

// 定期調査シート集計表出力
const populationViews = [
  {binding: 'zigyoujo', header: 'NW事業所', type: 'text', width: 110, readOnly: true},
  // {binding: 'chousaYear', header: '次回調査年度', type: 'text', width: 100, readOnly: true},
  {binding: 'chousaCompany', header: '調査会社', type: 'text', width: 100, readOnly: true},
  // {binding: 'kukakuBango', header: '区画番号', dataType: 'String', width: 100, readOnly: true},
  // {header: '契種', dataType: 'header', elems: [
  //   {binding: 'keiSyu1', header: '従量電灯Ａ等', dataType: 'String', width: 100, readOnly: true},
  //   {binding: 'keiSyu2', header: '時間帯別電灯', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'keiSyu3', header: '定額・街灯Ａ（口数）', dataType: 'String', width: 130, readOnly: true},
  //   {binding: 'keiSyu4', header: '定額（口数）（再掲）', dataType: 'String', width: 130, readOnly: true},
  //   {binding: 'keiSyu5', header: '街灯Ａ（口数）（再掲）', dataType: 'String', width: 130, readOnly: true},
  //   {binding: 'keiSyu6', header: '街灯Ａ（灯数）（再掲）', dataType: 'String', width: 130, readOnly: true},
  // ]},

  // {header: '調査業種', dataType: 'header', elems: [
  //   {binding: 'chousaIndustry2', header: '寝たきり', dataType: 'String', width: 80, readOnly: true},
  //   {binding: 'chousaIndustry3', header: 'プール', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'chousaIndustry4', header: '公衆浴場', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'chousaIndustry5', header: '学校保育所', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'chousaIndustry6', header: '病院診療所', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'chousaIndustry7', header: '老人福祉施設', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'chousaIndustry8', header: '重要文化財', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'syouKei', header: '合計（口数）', dataType: 'String', width: 90, readOnly: false},
  // ]},
  // {header: '調査管理区分', dataType: 'header', elems: [
  //   {binding: 'hijikaCategoryA', header: 'ＪＲ調査（別掲）', dataType: 'String', width: 150, readOnly: true},
  //   {binding: 'hijikaCategoryB', header: 'ＪＲ拒否（別掲）', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'hijikaCategoryC', header: '調査拒否（別掲）', dataType: 'String', width: 100, readOnly: false},
  //   {binding: 'hijikaCategory', header: '前年度繰越（別掲）', dataType: 'String', width: 100, readOnly: false},
  // ]},
  {header: '４年周期', dataType: 'header', elems: [
    {binding: 'keiSyu', header: '契種０１・０２', dataType: 'String', width: 150, readOnly: true},
    {binding: 'keiSyuOther', header: '左記以外', dataType: 'String', width: 100, readOnly: false},
  ]},

  {header: '毎年調査', dataType: 'header', elems: [
    {binding: 'chousaIndustry2', header: '２：寝たきり老人宅', dataType: 'String', width: 80, readOnly: true},
    {binding: 'chousaIndustry3', header: '３：プール', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry4', header: '４：浴場', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry5', header: '５：学校', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry6', header: '６：病院', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry7', header: '７：老人福祉施設', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry8', header: '８：重要文化財', dataType: 'String', width: 100, readOnly: false},
    {binding: 'chousaIndustry9', header: '９：学校でかつプール施設', dataType: 'String', width: 100, readOnly: false},
    {binding: 'syouKei', header: '小計', dataType: 'String', width: 100, readOnly: false},
  ]},
  {binding: 'souKei', header: '総計', dataType: 'String', width: 100, readOnly: false},
];

// 可否判定申込で使用する申込ステータスコード
// 作成中,可否判定受付中,強度計算中,可否判定中,可否判定済,本申込中,完結（期限切れ）,完結（取止め）,完結（申込済）
// const proprietyOrderStatus = ['00', '01', '02', '03', '04', '05', '91', '92', '93'];

/**
 * 定期調査シート集計表出力
 * 画面ID:SCD1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    let _list = ['メニュー'];
    _list.push(GMN.INVESTIGATION_REASON_LIST.name);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      // tabIndex: 1,
      transitionList: _list,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    // const {generalPurposeMap} = this.props;

    // this.setState({buttonDisabled: true});

    // // 検索条件
    // let wkData = {};
    // if (this.props.values) {
    //   wkData = JSON.parse(JSON.stringify(this.props.values));
    // }
    // wkData['OrderCategory__c'] = getCodeFromGeneralPurposeMap(generalPurposeMap, 'OrderCategory01', 2);
    // wkData['RecordType.DeveloperName'] = 'ProprietyJudgeOrder';
    // // 申込ステータスがなければ追加
    // if (!Object.hasOwnProperty.call(wkData, 'OrderStatus__c')) {
    //   wkData['OrderStatus__c'] = proprietyOrderStatus;
    // }

    // const appSortParams = {
    //   CreatedDate: -1,
    // };

    // if (this.props.hasOwnProperty('orderList')) {
    // // 申込テーブルからデータ取得
    // const response = await this.props.doGetOrderTypeList(
    //     wkData, orderListFields, appSortParams,
    //     'getAttachOrderList', [], '');
    // const errorCode = getErrorCode(response);
    // if (errorCode != API_CODE.SUCCESS) {
    //   this.props.doShowMessage({
    //     message: {
    //       id: 'CE0052',
    //       values: ['可否判定申込', '取得'],
    //     },
    //   });
    //   return false;
    // }

    // 件数超過エラー
    // const maxKensu = getDataFromGeneralPurposeMap(
    //     generalPurposeMap, 'DisplayMaxKensu1', 1).ValueNum1__c;
    // const dataLen = response.data.body.data ?
    //   response.data.body.data.length : 0;
    // if (dataLen >= maxKensu) {
    //   this.props.doShowMessage({
    //     message: 'CE0015',
    //   });
    // }

    // FlexGridに検索結果設定
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.setItems(this.props.orderList);
    // }
    // }
    // let values = this.props.values;
    // let _warningMessages = [];
    // if (!values.hasOwnProperty('sinseiId')) {

    // }
    // if (values === undefined) {
    //   let message1 = {
    //     id: 'BFY000017E',
    //     values: ['申請番号', ''],
    //   };
    //   _warningMessages.push(message1);
    //   let message2 = {
    //     id: 'BFY000017E',
    //     values: ['事業場', ''],
    //   };
    //   _warningMessages.push(message2);
    //   let message3 = {
    //     id: 'BFY000017E',
    //     values: ['作成日（自）', ''],
    //   };
    //   _warningMessages.push(message3);
    //   let message4 = {
    //     id: 'BFY000017E',
    //     values: ['作成日（至）', ''],
    //   };
    //   _warningMessages.push(message4);
    //   let message5 = {
    //     id: 'BFY000017E',
    //     values: ['ステータス', ''],
    //   };
    //   _warningMessages.push(message5);
    //   this.setState({
    //     warningMessages: _warningMessages,
    //   });
    //   return;
    // }

    // if (values.sinseiId == '') {
    //   let message = {
    //     id: 'BFE000261E',
    //     values: null,
    //   };
    //   _warningMessages.push(message);
    //   this.setState({
    //     warningMessages: _warningMessages,
    //   });
    //   return;
    // }
    const data =[
      {zigyoujo: '広島北NWC', chousaYear: '2025', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北NWC', chousaYear: '2026', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北NWC', chousaYear: '2027', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      {zigyoujo: '広島北NWC', chousaYear: '2028', kukakuBango: '00001', chousaCompany: '委託１', keiSyu: '100', keiSyuOther: '100', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2025', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2026', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2027', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},
      // {zigyoujo: '合計', chousaYear: '2028', kukakuBango: '00001', chousaCompany: '委託１', keiSyu1: '100', keiSyu2: '200', keiSyu3: '200', keiSyu4: '200', keiSyu5: '200', keiSyu6: '200', chousaIndustry2: '1', chousaIndustry3: '100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', syouKei: '1,333', souKei: '23,222', hijikaCategoryA: '100', hijikaCategoryB: '200', hijikaCategoryC: '300', hijikaCategory: '400'},

    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'TKSCS00001S',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_SECURITY_INFO);
  };

  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      // const {generalPurposeMap} = this.props;
      // this.props.doSetOrderId(null);
      // this.props.doSetOrderModifiedCondition(null, null);
      // this.props.doClearOrderInfo(); // 前回データをクリア
      // this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType2', 1));
      // this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      let params = {
        // waitUpdate,
        mod: 'I',
      };
      // 調査理由入力票画面に遷移
      setSessionObject(GMN.INVESTIGATION_REASON_INFO.id, params);
      this.props.navigate(GMN_PATH.INVESTIGATION_REASON_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 編集ボタン押下時
   */
  doEdit = () => {
    try {
      if (!this.gridRef ||
        !this.gridRef.current) {
        return;
      }

      const count = this.gridRef.current.selectedItemCount();
      if (count != 1) {
        this.props.doShowMessage({
          message: {
            id: 'CE0022',
          },
        });
        return;
      }

      const stbTypeSen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType1', 1);
      const stbTypeTen = getCodeFromGeneralPurposeMap(this.props.generalPurposeMap, 'StbType2', 1);
      const items = this.gridRef.current.selectedItem();
      this.props.doSetOrderId(items[0].dataItem.Id);
      this.props.doSetStbType(items[0].dataItem.StbType__c);
      this.props.doSetOrderModifiedCondition(
          items[0].dataItem.Id, items[0].dataItem.LastModifiedDate);
      if (items[0].dataItem.StbType__c == stbTypeSen) {
        this.props.history.push({pathname: '/SenProprietyBasicInfo'});
      }
      if (items[0].dataItem.StbType__c == stbTypeTen) {
        this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 削除ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef ||
      !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount();
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'BFY000023E',
            values: ['削除'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = items[rowIndex].index;
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();
    } catch (error) {
      // sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 帳票印刷
   */
  doPrint = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['屋内線定期調査シート集計表出力'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '1300px', height: 'auto', width: 'auto', marginTop: '20px'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
    };
    // return (
    //   <CustomFlexGrid ref={this.gridRef} {...props}>
    //     {populationViews}
    //   </CustomFlexGrid>
    // );
    // 一覧定義取得
    let viewElems = [];
    if (populationViews) {
      for (const view of populationViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              // viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          // viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }


    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   * @param {*} waitUpdate 申請番号
   * @param {*} sinnseiStatus ステータス
   */
  doEditLink = async (waitUpdate, sinnseiStatus) => {
    try {
      let params = {
        waitUpdate,
        mod: 'U',
      };
      if (sinnseiStatus =='作成中' || sinnseiStatus =='取止済') {
        params = {
          waitUpdate,
          mod: 'C',
        };
      } else if (sinnseiStatus =='承認待ち') {
        params = {
          waitUpdate,
          mod: 'U',
        };
      } else if (sinnseiStatus =='差戻対応中') {
        params = {
          waitUpdate,
          mod: 'M',
        };
      } else {
        params = {
          waitUpdate,
          mod: 'U',
        };
      }

      // 調査理由入力票画面に遷移
      setSessionObject(GMN.INVESTIGATION_REASON_INFO.id, params);
      this.props.navigate(GMN_PATH.INVESTIGATION_REASON_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doPrint}
            variant="contained"
            startIcon={<GetAppIcon />}
            // size="large"
          >
            <span>屋内線定期調査シート集計表</span>
          </PositiveButton>
        </Grid>
        {/* <Grid key="key1001Back" item>
          <BackButton props={this.props}/>
        </Grid> */}
        {/* <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={handleSubmit(this.doTenNext)}
            // disabled={this.state.buttonDisabled2}
            variant="contained"
            startIcon={<AddIcon />}
            // size="large"
          >
            <span>新規作成</span>
          </PositiveButton>
        </Grid> */}
        {/* <Grid key="key1001CreateTen3" item>
          <DangerButton
            id="btn1001CreateTen3"
            // onClick={handleSubmit(this.doTenNext)}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={this.state.buttonDisabled}
            onClick={this.doDelete}
            // size="large"
          >
            <span>削除</span>
          </DangerButton>
        </Grid> */}

      </Grid>
    );
  };

  /**
   * パンくず取得
   * @return {JSX.Element} パンくず
   */
  getBreadcrumbs() {
    const breadcrumbs = [
      <Link
        underline="hover"
        key="1"
        color="inherit"
        href="/menu"
      >
        メニュー
      </Link>,
      <Typography key="3" color="text.primary">
        定期調査シート集計表出力
      </Typography>,
    ];
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Breadcrumbs separator="＞" aria-label="breadcrumb">
            {breadcrumbs}
          </Breadcrumbs>
        </Grid>
      </Grid>
    );
    // return (
    //   <Grid container spacing={1}>
    //     <Grid item xs={12}>
    //       <Typography variant="title1"><u>メニュー</u> ＞ 調査理由入力票一覧</Typography>
    //     </Grid>
    //   </Grid>
    // );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      // handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          {this.getBreadcrumbs()}
          {/* <CustomBreadcrumbs key="keyBFE10112GBreadcrumbs"
            items={this.state.transitionList}/> */}
          <Grid key="keySCC1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            {/* <Typography variant="h6" gutterBottom>&nbsp;</Typography> */}
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
              direction={'row'}
            >
              <Grid key="zigyoujo" item xs={12} sm={2}>
                <Field
                  id="zigyoujo"
                  name=""
                  // variant="standard"
                  component={renderSelect}
                  className={classes.fields}
                  label="NW事業所"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
                  <MenuItem value={6120}>{'山口NWC'}</MenuItem>
                </Field>
              </Grid>
              {/* <Grid key="kukakuBango" item xs={12} sm={2}>
                <Field
                  id="kukakuBango"
                  name="kukakuBango"

                  component={renderTextField}
                  className={classes.fields}
                  label="区画番号"
                  fullWidth
                  type="text"
                  required={false}
                  validate={[
                    validateRule.number,
                    validateRule.maxLength(5),
                  ]}
                />
              </Grid> */}
              {/* <Grid key="chousaNendoFrom" item xs={12} sm={2}>
                <Field
                  id="chousaNendoFrom"
                  name="calenchousaNendoFromdarfrom"
                  component={renderTextField}
                  className={classes.fields}
                  fullWidth
                  label="調査年度"
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                    validateRule.number,
                    validateRule.correctFromDate(values ? values['chousaNendoTo'] : null),
                  ]}
                />
              </Grid>
              <Typography sx={{margin: '18px 0px 20px 25px'}}>
              ～
              </Typography>
              <Grid key="chousaNendoTo" item xs={12} sm={2}>
                <Field
                  id="chousaNendoTo"
                  name="chousaNendoTo"
                  component={renderTextField}
                  className={classes.fields}
                  fullWidth
                  label="調査年度"
                  type="text"
                  // format="month"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                    validateRule.number,
                    validateRule.correctDate(values ? values['chousaNendoFrom'] : null),
                  ]}
                />
              </Grid> */}
              {/* <Grid key="chousaNendo" item xs={12} sm={2}>
                <Field
                  id="chousaNendo"
                  name="chousaNendo"

                  component={renderTextField}
                  className={classes.fields}
                  label="調査年度"
                  fullWidth
                  type="text"
                  required={false}
                  validate={[
                    validateRule.number,
                    validateRule.maxLength(4),
                  ]}
                />
              </Grid> */}
              <Grid key="chousaKaisha" item xs={12} sm={2}>
                <Field
                  id="chousaKaisha"
                  name="chousaKaisha"
                  component={renderSelect}
                  className={classes.fields}
                  label="調査会社"
                  fullWidth
                  required={false}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                  }}
                >
                  <MenuItem value="">&nbsp;</MenuItem>
                  <MenuItem value={'中電'}>{'中電'}</MenuItem>
                  <MenuItem value={'1'}>{'委託１'}</MenuItem>
                  <MenuItem value={'2'}>{'委託２'}</MenuItem>
                  <MenuItem value={'3'}>{'委託３'}</MenuItem>
                </Field>
              </Grid>
            </Grid>
            <Grid key="contactStatus" item xs={12} sm={7}>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="label" sx={{margin: '20px 10px 0px 20px', fontSize: '18px'}}>出力帳票選択</FormLabel>
                <FormGroup row={true}>
                  <Field className={classes.checkbox}
                    id="contactStatusDecoupling"
                    name="contactStatusDecoupling"
                    component={renderCheckbox}
                    label="ＮＷＣ計"
                    validate={[]}
                    sx={{marginLeft: '20px'}}
                  />
                  <Field className={classes.checkbox}
                    id="contactStatuNotcontacted"
                    name="contactStatusNotcontacted"
                    component={renderCheckbox}
                    label="統括ＮＷＣ計"
                    validate={[]}
                    sx={{marginLeft: '10px'}}
                  />
                  <Field className={classes.checkbox}
                    id="contactStatusIncontacted"
                    name="contactStatusIncontacted"
                    component={renderCheckbox}
                    label="県別計"
                    validate={[]}
                    sx={{marginLeft: '10px'}}
                  />
                  <Field className={classes.checkbox}
                    id="contactStatusComplete"
                    name="contactStatusComplete"
                    component={renderCheckbox}
                    label="本店計"
                    validate={[]}
                    sx={{marginLeft: '10px'}}
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className={classes.button}
                  // size="large"
                  // onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              {/* <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className={clsx(classes.button)}
                  // size="large"
                  // onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid> */}
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '0px'}} />
          {/* <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid> */}
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
